import { ReactNode, useState } from 'react';

import { Box, Button, Divider, styled, SxProps, Typography } from '@mui/material';
import { X } from 'phosphor-react';

import { black, primaryColors } from '~components/theme/styles/colors';

const AccountPanelButton = styled(Button)({
  background: black['85%'],
  padding: '16px 32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: primaryColors[400],
  width: '100%',
  minWidth: 0,
  '&:hover': {
    background: black['85%'],
  },
});

type AccountPanelProps = {
  titleContent: ReactNode;
  titleIcon: ReactNode;
  children?: ReactNode;
  forceOpen?: boolean;
  panelBodySx?: SxProps;
  onClick?: () => void;
};

export const AccountPanel: React.FC<AccountPanelProps> = ({
  titleContent,
  titleIcon,
  children,
  forceOpen,
  panelBodySx,
  onClick,
}) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <Box
      sx={{
        borderRadius: '4px',
        backdropFilter: 'blur(4px)',
      }}
    >
      <AccountPanelButton
        sx={{
          pointerEvents: forceOpen ? 'none' : undefined,
          ...(forceOpen ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 } : {}),
        }}
        onClick={() => {
          onClick ? onClick() : setAccordionOpen(prev => !prev);
        }}
      >
        <Typography variant="label3" sx={{ color: primaryColors[400] }}>
          {titleContent}
        </Typography>
        {accordionOpen && !forceOpen ? (
          <Button sx={{ minWidth: 0, padding: 0 }}>
            <X size={22} />
          </Button>
        ) : (
          titleIcon
        )}
      </AccountPanelButton>

      {(accordionOpen || forceOpen) && (
        <>
          <Divider sx={{ margin: 0 }} />
          <Box sx={{ padding: '16px 32px', background: black['45%'], ...panelBodySx }}>{children}</Box>
        </>
      )}
    </Box>
  );
};
